<app-composite-component 
    [template_page]="pageContent" 
/>

<ng-template #pageContent>
    <page-content class="page-content" [@.disabled]="loadingPage$$()">
        <div class="details-section">
            @if (tabLayout$$()) {
                <app-section-details-tab-layout
                    (btnCancel)="emit_btnCancel()"
                    (btnDelete)="emit_btnDelete()"
                    (btnEdit)="emit_btnEdit()"
                    [btnCancelData]="btnCancelData$$()"
                    [btnDeleteData]="btnDeleteData$$()"
                    [btnEditData]="btnEditData$$()"
                    [btnSaveData]="btnSaveData$$()"
                />
            } @else {
                <app-section-details 
                    (btnCancel)="emit_btnCancel()"
                    (btnDelete)="emit_btnDelete()"
                    (btnEdit)="emit_btnEdit()"
                    (btnSave)="emit_btnSave()"
                    [btnCancelData]="btnCancelData$$()"
                    [btnDeleteData]="btnDeleteData$$()"
                    [btnEditData]="btnEditData$$()"
                    [btnSaveData]="btnSaveData$$()"
                />
            }
        </div>
    </page-content>
</ng-template>


<ng-template #footerContentBlock>
    <buttons-group 
        [@slideTop]="pageMode$$()" 
        [class]="pageMode$$()"
    >
        @if (sectionDetails_show$$()) {
            <ng-container *ngTemplateOutlet="sectionDetails_buttons_template$$()" />
        }
        @if (sectionEdit_show$$()) {
            <ng-container *ngTemplateOutlet="sectionEdit_buttons_template$$()" />
        }
    </buttons-group>
</ng-template>
